export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

//For TENANTs reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_TENANT_SUCCESS = "LOAD_TENANT_SUCCESS";
export const DELETE_TENANT_SUCCESS = "DELETE_TENANT_SUCCESS";
export const UPDATE_TENANT_SUCCESS = "UPDATE_TENANT_SUCCESS";
export const ADD_TENANT_SUCCESS = "ADD_TENANT_SUCCESS";

//For TENANT reducer, single record read for editing and updating a single TENANT record
export const READ_TENANT_SUCCESS = "READ_TENANT_SUCCESS";

//For Artists reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_ARTIST_SUCCESS = "LOAD_ARTIST_SUCCESS";
export const DELETE_ARTIST_SUCCESS = "DELETE_ARTIST_SUCCESS";
export const UPDATE_ARTIST_SUCCESS = "UPDATE_ARTIST_SUCCESS";
export const ADD_ARTIST_SUCCESS = "ADD_ARTIST_SUCCESS";

//For Artist reducer, single record read for editing and updating a single Artist record
export const READ_ARTIST_SUCCESS = "READ_ARTIST_SUCCESS";

//For CLAUSEs reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_CLAUSE_SUCCESS = "LOAD_CLAUSE_SUCCESS";
export const DELETE_CLAUSE_SUCCESS = "DELETE_CLAUSE_SUCCESS";
export const UPDATE_CLAUSE_SUCCESS = "UPDATE_CLAUSE_SUCCESS";
export const ADD_CLAUSE_SUCCESS = "ADD_CLAUSE_SUCCESS";

//For CLAUSE reducer, single record read for editing and updating a single CLAUSE record
export const READ_CLAUSE_SUCCESS = "READ_CLAUSE_SUCCESS";

//For CONSENTs reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_CONSENT_SUCCESS = "LOAD_CONSENT_SUCCESS";
export const DELETE_CONSENT_SUCCESS = "DELETE_CONSENT_SUCCESS";
export const UPDATE_CONSENT_SUCCESS = "UPDATE_CONSENT_SUCCESS";
export const ADD_CONSENT_SUCCESS = "ADD_CONSENT_SUCCESS";

//For CONSENT reducer, single record read for editing and updating a single CONSENT record
export const READ_CONSENT_SUCCESS = "READ_CONSENT_SUCCESS";

//For KioskUsers reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_KIOSKUSER_SUCCESS = "LOAD_KIOSKUSER_SUCCESS";
export const DELETE_KIOSKUSER_SUCCESS = "DELETE_KIOSKUSER_SUCCESS";
export const UPDATE_KIOSKUSER_SUCCESS = "UPDATE_KIOSKUSER_SUCCESS";
export const ADD_KIOSKUSER_SUCCESS = "ADD_KIOSKUSER_SUCCESS";

//For KIOSKUSER reducer, single record read for editing and updating a single KIOSKUSER record
export const READ_KIOSKUSER_SUCCESS = "READ_KIOSKUSER_SUCCESS";

//For Submissions reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_SUBMISSION_SUCCESS = "LOAD_SUBMISSION_SUCCESS";
export const DELETE_SUBMISSION_SUCCESS = "DELETE_SUBMISSION_SUCCESS";
export const UPDATE_SUBMISSION_SUCCESS = "UPDATE_SUBMISSION_SUCCESS";
export const ADD_SUBMISSION_SUCCESS = "ADD_SUBMISSION_SUCCESS";

//For SUBMISSION reducer, single record read for editing and updating a single SUBMISSION record
export const READ_SUBMISSION_SUCCESS = "READ_SUBMISSION_SUCCESS";

//For Subscriptions reducer, all these return an array of existing records depending on Create, Delete, Update or Load.
export const LOAD_SUBSCRIPTION_SUCCESS = "LOAD_SUBSCRIPTION_SUCCESS";
export const DELETE_SUBSCRIPTION_SUCCESS = "DELETE_SUBSCRIPTION_SUCCESS";
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS";
export const ADD_SUBSCRIPTION_SUCCESS = "ADD_SUBSCRIPTION_SUCCESS";

//For Subscription reducer, single record read for editing and updating a single SUBSCRIPTION record
export const READ_SUBSCRIPTION_SUCCESS = "READ_SUBSCRIPTION_SUCCESS";






// WEBPACK FOOTER //
// ./src/actions/actionTypes.js